export default __webpack_public_path__ + "static/corona-bb7e4ce95d4bc4f54b438f60dd0535a4.png";